export default {
  customer: null
}
